/**
 * Pure decision logic for `useCancelClientNavigation`.
 *
 * Returns `true` when a client-side navigation must be cancelled and replaced
 * with a hard navigation so the Cloudflare Worker re-runs (it does not run on
 * client transitions). Extracted as a pure function so the bucketing rules can
 * be unit tested without a React renderer.
 */
export function shouldCancelClientNavigation({
  currentPath,
  nextPathname,
  environmentName,
  experimentedPages,
}: {
  currentPath: string;
  nextPathname: string;
  environmentName?: string;
  experimentedPages: { pathRegex: RegExp }[];
}): boolean {
  if (nextPathname.includes('coupon=')) {
    return true;
  }

  // Allow client-side transitions only within checkout.
  if (nextPathname.startsWith('/checkout/') && !currentPath.startsWith('/checkout/')) {
    return true;
  }

  // Entering the catalog from outside still needs the worker to bucket experiments.
  if (nextPathname.startsWith('/catalog') && !currentPath.startsWith('/catalog')) {
    return true;
  }

  if (nextPathname.startsWith('/legal/')) {
    return true;
  }

  if (environmentName !== 'test') {
    return experimentedPages.some((experimentedPage) => experimentedPage.pathRegex.test(nextPathname));
  }

  return false;
}
